import React, { useState, useEffect, useRef, useCallback, Fragment } from 'react';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { useForm, Controller } from "react-hook-form";
import JoditEditor, { Jodit } from 'jodit-react';
import { toast, confirm } from '@rickylandino/react-messages';
import { UploadOutlined } from '@ant-design/icons';
import { Select, Upload, Button, message } from 'antd';
import Axios from '../../config/axios';
import { sendRepEmail } from '../../services/EmailSenderService';
import { insertCustomerNote } from '../../services/NotesService';
import { convertHtmlToText } from '../Helpers/ManipulateHTML';
import { useRecoilState } from 'recoil';
import { persistentEmails, insertPersistentEmail, updatePersistentEmail, deletePersistentEmailAndAttachments } from '../../services/PersistEmailService';
import { persistentNotes } from '../../services/PersistNotes';
import { persistentFilteredNotes } from '../../services/PersistNotes';
import { notesFilterType } from '../../services/PersistNotes';

export default function SendEmailSlider(props) {
    const [state, setState] = useState({
        showPane: false,
        dataLoaded: false,
        emailInformation: {}
    });

    const { Option } = Select;

    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [templateDropdown, setTemplateDropdown] = useState(props?.templates?.filter(t => t.templateType === 'email') || []);
    const [emailTemplates, setEmailTemplates] = useState([]);
    const [editorSignatures, setEditorSignatures] = useState({});
    const [repEmailImages, setRepEmailImages] = useState([]);
    const [emailSignatures, setEmailSignatures] = useState([]);
    const [editorImages, setEditorImages] = useState({});
    const [mergeFields, setMergeFields] = useState([]);
    const [editorMergeFields, setEditorMergeFields] = useState([]);
    const [file, setFile] = useState(null);
    const [files, setFiles] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [emailSenderInstanceId, setEmailSenderInstanceId] = useState(Date.now());
    const [localPersistentEmails, setPersistentEmails] = useRecoilState(persistentEmails);
    const [localPersistentNotes, setPersistentNotes] = useRecoilState(persistentNotes);
    const [localPersistentFilteredNotes, setPersistentFilteredNotes] = useRecoilState(persistentFilteredNotes);
    const [localNotesFilterType, setNotesFilterType] = useRecoilState(notesFilterType);

    const { register, getValues, setValue, control, watch } = useForm();
    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

    const editor = useRef(null);
    const [content, setContent] = useState("");

    // Overlay DnD state
    const [dndOverlayActive, setDndOverlayActive] = useState(false);
    const [dndOverlayHighlight, setDndOverlayHighlight] = useState(false);
       

    // DnD overlay logic
    useEffect(() => {
        let dragCounter = 0;
        function onDragEnter(e) {
            if (e.dataTransfer && e.dataTransfer.types && Array.from(e.dataTransfer.types).includes('Files')) {
                dragCounter++;
                setDndOverlayActive(true);
                setDndOverlayHighlight(true);
            }
        }
        function onDragOver(e) {
            if (e.dataTransfer && e.dataTransfer.types && Array.from(e.dataTransfer.types).includes('Files')) {
                e.preventDefault();
                setDndOverlayHighlight(true);
            }
        }
        function onDragLeave(e) {
            dragCounter--;
            if (dragCounter <= 0) {
                setDndOverlayHighlight(false);
                setDndOverlayActive(false);
                dragCounter = 0;
            }
        }
        function onDrop(e) {
            dragCounter = 0;
            setDndOverlayHighlight(false);
            setDndOverlayActive(false);
        }
        window.addEventListener('dragenter', onDragEnter);
        window.addEventListener('dragover', onDragOver);
        window.addEventListener('dragleave', onDragLeave);
        window.addEventListener('drop', onDrop);
        return () => {
            window.removeEventListener('dragenter', onDragEnter);
            window.removeEventListener('dragover', onDragOver);
            window.removeEventListener('dragleave', onDragLeave);
            window.removeEventListener('drop', onDrop);
        };
    }, []);

    // Overlay drop handler
    function handleOverlayDrop(e) {
        e.preventDefault();
        setDndOverlayHighlight(false);
        setDndOverlayActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const file = e.dataTransfer.files[0];
            if (file.type === 'text/html' || file.name.endsWith('.html') || file.name.endsWith('.htm')) {
                const reader = new window.FileReader();

                //this replaces all content in the editor
                //reader.onload = function (evt) {
                //    setContent(evt.target.result);
                //};

                //this appends the dropped file at the end of the content
                reader.onload = (evt) => {
                    setContent(prev => (prev || '') + evt.target.result);
                };

                reader.readAsText(file);
            } else {
                toast.error("Only HTML files are allowed (.html or .htm)");
                /*alert('Please drop an HTML file (.html or .htm)');*/
            }
        }
    }

    useEffect(() => {
        if (props.showPane) {
            setState({
                ...state,
                dataLoaded: false
            });

            // Load the contacts for the org this email is about so the user can
            // pick them into the To:/Cc: fields. Keep only contacts with an email.
            const companyId = props.emailInformation?.selectedCustomer?.id;
            if (companyId) {
                Axios.post(`/api/GetCompanyContacts`, {
                    company_id: companyId,
                    jobshopdivision: userInfo.jobShopDivision
                }).then(response => {
                    setContacts((response.data || []).filter(c => c.email && c.email.trim()));
                }).catch(error => {
                    console.log(error);
                });
            } else {
                setContacts([]);
            }

            Axios.get(`/api/InitializeEmailSender`, {
                params: {
                    ownedby: userInfo.userId,
                    division: userInfo.jobShopDivision
                }
            }).then(response => {
                let templates = [];
                let signatures = [];

                setValue('repDocuments', response.data.repDocuments);

                for (var i = 0; i < response.data.templates.length; i++) {
                    if (response.data.templates[i].templateType === 'email') {
                        if (response.data.templates[i].shared === true && response.data.templates[i].ownedBy !== userInfo.userId) {
                            response.data.templates[i].templateName += ' (shared by ' + response.data.templates[i].ownedBy + ')';
                        }
                        templates.push(response.data.templates[i]);
                    }
                    else {
                        signatures.push(response.data.templates[i]);
                    }
                }

                setEmailTemplates(templates);
                setEmailSignatures(signatures);
                setRepEmailImages(response.data.repEmailImages);

                //load merge fields for editor dropdown
                let mergeFields = ["Contact Name", "Company Name"];
                setMergeFields(mergeFields);

                setTemplateDropdown(templates);

                setValue('testEmailRecipient', userInfo.email);

                setState({
                    ...state,
                    emailInformation: props.emailInformation,
                    dataLoaded: true
                });
            }).catch(error => {
                console.log(error);
            });
        }
    }, [props.showPane]);

    useEffect(() => {
        if (state.dataLoaded === true) {
            if (state.emailInformation.id !== '') {
                let fileList = [];

                if (state.emailInformation.fileList && state.emailInformation.fileList.length > 0) {
                    state.emailInformation.fileList.forEach(file => {
                        fileList.push(new File([file.documentData], file.name, {
                            type: "application/pdf"
                        }));
                    });
                }

                var saveToNotes = state.emailInformation.saveToNotes === true ? true : (state.emailInformation.saveToNotes === false) ? false : true;
                var saveToImap = state.emailInformation.saveToImap === true ? true : (state.emailInformation.saveToImap === false) ? false : true;

                if (state.emailInformation?.templateName) {

                    let foundTemplate = templateDropdown.find(t => t.templateName === state.emailInformation.templateName);
                    setSelectedTemplate(foundTemplate);
                }

                setValue('templateName', state.emailInformation.templateName);
                setValue('sendTo', state.emailInformation.sendTo || state.emailInformation.selectedContact.email);
                setValue('sendCc', state.emailInformation.sendCc || '');
                setValue('emailSubject', state.emailInformation.emailSubject || '');
                setValue('saveToNotes', saveToNotes);
                setValue('saveToImap', saveToImap);
                setValue('selectedRepDocuments', state.emailInformation?.repDocumentsToUpdate?.map(rd => rd.repDocumentLibrary_ID) || []);
                setContent(state.emailInformation.emailContent || '');
                setFileList(fileList);
            } else {
                addPersistentEmailInstance();

                //setTemplateDropdown(emailTemplates);
                setSelectedTemplate(null);
                //setValue('selectedTemplateText', null);
                setValue('templateName', '');
                setValue('sendTo', state.emailInformation.selectedContact.email);
                setValue('emailSubject', '');
                setValue('saveToNotes', true);
                setValue('saveToImap', true);
                setContent('');
            }

            setState({
                ...state,
                showPane: true
            });
        }
    }, [state.dataLoaded]);

    //****************************
    //Jodit Editor custom buttons
    //****************************
    useEffect(() => {
        if (!emailSignatures?.length) return;

        const signatureList = {};

        emailSignatures.forEach(sig => {
            const commandName = `sig_${sig.repEmailTemplateLibrary_ID}`;

            // register the command ONCE
            Jodit.defaultOptions.controls[commandName] = {
                exec: (editor) => {
                    editor.s.insertHTML(
                        `<div id="signature">${sig.stringContent}</div>`
                    );
                }
            };

            // dropdown item points to the command
            signatureList[commandName] = {
                text: sig.templateName
            };
        });

        setEditorSignatures(signatureList);
    }, [emailSignatures]);

    useEffect(() => {
        if (!mergeFields?.length) return;

        const mergeFieldList = {};

        mergeFields.forEach(field => {
            const commandName = `merge_${field.replace(/\s+/g, '_')}`; // unique command name

            // register command
            Jodit.defaultOptions.controls[commandName] = {
                exec: (editor) => {
                    editor.s.insertHTML(DropInMergeField(field));
                }
            };

            // add to dropdown list
            mergeFieldList[commandName] = {
                text: field
            };
        });

        setEditorMergeFields(mergeFieldList); // you�ll need a separate state
    }, [mergeFields]);

    useEffect(() => {
        if (!repEmailImages?.length) return;

        const imageList = {};

        repEmailImages.forEach(img => {
            // sanitize key
            const commandName = `img_${img.replace(/[^a-zA-Z0-9_]/g, '_')}`;

            // register command
            if (!Jodit.defaultOptions.controls[commandName]) {
                Jodit.defaultOptions.controls[commandName] = {
                    exec: (editor) => {
                        editor.s.insertHTML(
                            `<a href="https://d2p-show-rep-email-images.nyc3.digitaloceanspaces.com/${encodeURIComponent(img)}">
                            <img src="https://d2p-show-rep-email-images.nyc3.digitaloceanspaces.com/${encodeURIComponent(img)}" />
                        </a>`
                        );
                    }
                };
            }

            imageList[commandName] = { text: img };
        });

        setEditorImages(imageList); // reactive state
    }, [repEmailImages]);
    //********************************
    //End Jodit Editor custom buttons
    //********************************

    function addPersistentEmailInstance() {

        var persistentEmailCopy = [...localPersistentEmails];

        var newPersistentEmail = {
            id: emailSenderInstanceId.toString(),
            sendTo: state.emailInformation.selectedContact?.email,
            selectedCustomer: state.emailInformation.selectedCustomer,
            selectedContact: state.emailInformation.selectedContact,
            selectedCustomerId: state.emailInformation.selectedCustomer.id,
            selectedContactId: state.emailInformation.selectedContact.contact_id,
            userId: userInfo.userId
        }

        persistentEmailCopy.push(newPersistentEmail);

        setPersistentEmails(persistentEmailCopy);

        //TODO - Add newPeristentEmail to db
        insertPersistentEmail(newPersistentEmail);
    }

    function updatePersistentEmailInstance() {
        var persistentEmailCopy = [...localPersistentEmails];
        let idToCheckAgainst = state.emailInformation?.id || emailSenderInstanceId.toString();

        let idx = persistentEmailCopy.findIndex(item => item.id === idToCheckAgainst);

        let tempObj = { ...persistentEmailCopy[idx] };

        let repDocumentsToUpdate = [];

        if (getValues().selectedRepDocuments?.length > 0) {
            getValues().selectedRepDocuments.forEach(id => {
                var item = getValues().repDocuments.find(rd => rd.repDocumentLibrary_ID === id);
                repDocumentsToUpdate.push(item);
            });
        }

        tempObj = {
            ...tempObj,
            ...getValues(),
            fileList: [...fileList],
            emailContent: content,
            repDocumentsToUpdate
        };

        persistentEmailCopy[idx] = tempObj;
        setPersistentEmails(persistentEmailCopy);
        updatePersistentEmail(tempObj);

    }

    function removePersistentEmailAndHidePane() {
        let persistentEmailCopy = [...localPersistentEmails];

        let idToCheckAgainst = state.emailInformation?.id || emailSenderInstanceId.toString();
        let idx = persistentEmailCopy.findIndex(item => item.id === idToCheckAgainst);

        let persistentEmailToRemove = persistentEmailCopy[idx];
        deletePersistentEmailAndAttachments(persistentEmailToRemove);

        persistentEmailCopy.splice(idx, 1);
        setPersistentEmails(persistentEmailCopy);

        setState({
            ...state,
            showPane: false,
            dataLoaded: false
        });

        setTimeout(() => {
            props.hidePane();
        }, 1000);
    }

    function hidePane() {
        setState({
            ...state,
            showPane: false,
            dataLoaded: false
        });

        setTimeout(() => {
            props.hidePane();
        }, 1000);

        updatePersistentEmailInstance();
    }

    function PopulateMergeFields(templateContent) {
        let updatedTemplateContent = templateContent;

        if (state.emailInformation) {
            updatedTemplateContent = updatedTemplateContent.replace("[[Contact Name]]", state.emailInformation.selectedContact?.jsS_name);
            updatedTemplateContent = updatedTemplateContent.replace("[[Company Name]]", state.emailInformation.selectedCustomer?.name);
        } else {
            updatedTemplateContent = updatedTemplateContent.replace("[[Contact Name]]", state.emailInformation.selectedContact?.jsS_name);
            updatedTemplateContent = updatedTemplateContent.replace("[[Company Name]]", state.emailInformation.selectedCustomer?.name);
        }

        return updatedTemplateContent;
    }

    function DropInMergeField(mergeField) {
        var returnField;

        console.log(mergeField);

        switch (mergeField) {
            case 'Contact Name':
                returnField = state.emailInformation.selectedContact.jsS_name;
                break;
            case 'Company Name':
                returnField = state.emailInformation.selectedCustomer.name;
                break;
        }

        return returnField;
    }

    function selectTemplate(e) {
        e.preventDefault();
        let target = e.target;
        let name = target.name;
        let value = target.value;

        if (value) {
            let foundTemplate = templateDropdown.find(t => t.repEmailTemplateLibrary_ID === parseInt(value));

            if (foundTemplate) {
                setSelectedTemplate(foundTemplate);
                //setValue('selectedTemplateText', foundTemplate.repEmailTemplateLibrary_ID);
                setValue('templateName', foundTemplate.templateName);
                setValue('emailSubject', foundTemplate.templateSubject);
                setContent(PopulateMergeFields(foundTemplate.stringContent));
            } else {
                setSelectedTemplate(null);
                //setValue('selectedTemplateText', null);
                setValue('templateName', '');
                setValue('emailSubject', '');
                setContent('');
            }
        } else {
            setSelectedTemplate(null);
            //setValue('selectedTemplateText', null);
            setValue('templateName', '');
            setValue('emailSubject', '');
            setContent('');
        }
    }

    function addContactToField(fieldName, email) {
        if (!email) return;
        const current = getValues()[fieldName] || '';
        const existing = current.split(/[;,]/).map(s => s.trim()).filter(Boolean);
        if (existing.some(e => e.toLowerCase() === email.toLowerCase())) return; // already present
        setValue(fieldName, [...existing, email].join('; '));
    }

    function handleSendTestEmail() {
        const isEditorEmpty =
            !content ||
            content.trim() === '<p><br></p>' ||
            content.trim() === '<p></p>';

        if (getValues().testEmailRecipient.trim() === '' || getValues().emailSubject.trim() === '' || isEditorEmpty) {
            toast.error("Test Email Recipient, Subject and Body Content are required fields");

            return;
        }

        // Validate list of sendTo and sendCC email addresses
        var validator = require("node-email-validation");
        var splitList;

        //Validate list of testEmailRecipient email address
        if (getValues().testEmailRecipient.includes(";")) {
            splitList = getValues().testEmailRecipient.split(';');
        }
        else if (getValues().testEmailRecipient.includes(",")) {
            splitList = getValues().testEmailRecipient.split(',');
        }
        if (splitList === undefined) {
            if (validator.is_email_valid(getValues().testEmailRecipient) === false) {
                toast.error("Invalid format found for 'Test Email' address");
                return;
            }
        }
        else {
            for (let i = 0; i < splitList.length; i++) {
                if (validator.is_email_valid(splitList[i].trim()) === false) {
                    toast.error("Invalid format found for 'Email Test' addresses");
                    return;
                }
            }
        }

        const key = "sendEmail";
        message.loading({
            content: 'Sending Test Email...',
            key,
            duration: 0,
            style: {
                position: "fixed",
                bottom: 0,
                left: 0
            },
        });

        sendRepEmail(userInfo.userId, getValues().testEmailRecipient, "", getValues().emailSubject, content, getValues().selectedRepDocuments, fileList, false).then(data => {
            message.destroy(key);

            if (data.includes("Success:")) {
                toast.success(data.replace("Success:", ""));
            }
            else if (data.includes("Error:")) {
                toast.error(data.replace("Error:", ""));
            }
            //else {
            //    toast.info(data.replace("Info:", ""));
            //    hidePane();
            //}

        }).catch(error => {
            toast.error("Problem encountered sending test email");
        });
    }

    function handleSendEmail() {
        const isEditorEmpty =
            !content ||
            content.trim() === '<p><br></p>' ||
            content.trim() === '<p></p>';

        if (getValues().sendTo.trim() === '' || getValues().emailSubject.trim() === '' || isEditorEmpty) {
            toast.error("Email To, Subject and Body Content are required fields");

            return;
        }

        // Validate list of sendTo and sendCC email addresses
        var validator = require("node-email-validation");
        var splitList;

        //Validate list of sendTo email addresses
        if (getValues().sendTo.includes(";")) {
            splitList = getValues().sendTo.split(';');
        }
        else if (getValues().sendTo.includes(",")) {
            splitList = getValues().sendTo.split(',');
        }
        if (splitList === undefined) {
            if (validator.is_email_valid(getValues().sendTo) === false) {
                toast.error("Invalid format found for 'To' address");
                return;
            }
        }
        else {
            for (let i = 0; i < splitList.length; i++) {
                if (validator.is_email_valid(splitList[i].trim()) === false) {
                    toast.error("Invalid format found for 'To' addresses");
                    return;
                }
            }
        }

        //Validate list of sendCc email addresses
        if (getValues().sendCc.trim() !== '') {
            if (getValues().sendCc.includes(";")) {
                splitList = getValues().sendCc.split(';');
            }
            else if (getValues().sendCc.includes(",")) {
                splitList = getValues().sendCc.split(',');
            }
            if (splitList === undefined) {
                if (validator.is_email_valid(getValues().sendCc) === false) {
                    toast.error("Invalid format found for 'Cc' address");
                    return;
                }
            }
            else {
                for (let i = 0; i < splitList.length; i++) {
                    if (validator.is_email_valid(splitList[i].trim()) === false) {
                        toast.error("Invalid format found for 'Cc' addresses");
                        return;
                    }
                }
            }
        }

        const key = "sendEmail";
        message.loading({
            content: 'Sending Email...',
            key,
            duration: 0,
            style: {
                position: "fixed",
                bottom: 0,
                left: 0
            },
        });

        sendRepEmail(userInfo.userId, getValues().sendTo, getValues().sendCc, getValues().emailSubject, content, getValues().selectedRepDocuments, fileList, getValues().saveToImap).then(data => {
            if (getValues().saveToNotes === true) {
                var customerId;
                if (state.emailInformation) {
                    customerId = state.emailInformation.selectedCustomer.id;
                }
                else {
                    customerId = props.selectedCustomer.id;
                }

                var note = "";
                if (content.includes("<div id=\"signature\"")) {
                    note = content.substring(0, content.indexOf("<div id=\"signature\""));
                }
                else {
                    note = content;
                }

                note = convertHtmlToText(note);

                var note_date = new Date();
                var division = userInfo.jobShopDivision;
                var userId = userInfo.userId;
                var pinned = false;

                insertCustomerNote(customerId, note, note_date, division, userId, pinned);
                getCustomerNotes(customerId, userInfo.jobShopDivision, userInfo.userid, 'allDivisionNotes');
            }

            message.destroy(key);

            if (data.includes("Success:")) {
                toast.success(data.replace("Success:", ""));
                removePersistentEmailAndHidePane();
                //hidePane();
            }
            else if (data.includes("Error:")) {
                toast.error(data.replace("Error:", ""));
            }
            else {
                toast.info(data.replace("Info:", ""));
                hidePane();
            }

        }).catch(error => {
            toast.error("Problem encountered sending email");
        });
    }

    function getCustomerNotes(id, division, user, notesfiltertype) {
        let postdata = {};
        postdata.userid = user;
        postdata.company_id = id;
        postdata.jobshopdivision = division;
        postdata.notesfiltertype = notesfiltertype;

        Axios.post(`/api/GetCustomerNotes`, postdata
        ).then(response => {
            const notes = response.data.displayList;

            setPersistentNotes(notes);
            setPersistentFilteredNotes(notes);
        }).catch(error => {
            console.log(error);
        });
    }

    function handleDocLibraryAttachmentsChange(value) {
        //TODO
        setValue('selectedRepDocuments', value);
        setState({ ...state });
    }

    function handleSavetoNotesChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        //TODO
        setValue('saveToNotes', value);

        //setState({
        //    ...state,
        //});
    }

    function handleSavetoImapChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        //TODO
        setValue('saveToImap', value);

        setState({
            ...state,
        });
    }

    function removePersistentEmail() {
        confirm({
            title: "You are about to permanently delete this staged email",
            content: "Are you sure you would like continue?",
            buttons: ["Yes", "No"],
        }, (buttonPressed) => {
            if (buttonPressed === 'Yes') {
                let persistentEmailCopy = [...localPersistentEmails];

                let idToCheckAgainst = state.emailInformation?.id || emailSenderInstanceId.toString();
                let idx = persistentEmailCopy.findIndex(item => item.id === idToCheckAgainst);

                let persistentEmailToRemove = persistentEmailCopy[idx];
                deletePersistentEmailAndAttachments(persistentEmailToRemove);

                persistentEmailCopy.splice(idx, 1);
                setPersistentEmails(persistentEmailCopy);

                setState({
                    ...state,
                    showPane: false,
                    dataLoaded: false
                });

                setTimeout(() => {
                    props.hidePane();
                }, 1000);

                return 0;
            } else {
                return 0;
            }
        });
    }

    var joditButtons = [...Jodit.defaultOptions.buttons];

    joditButtons.push({
        name: 'Signatures',
        text: 'Signatures',
        list: editorSignatures
    });
    joditButtons.push({
        name: 'Merge Fields',
        text: 'Merge Fields',
        list: editorMergeFields
    });
    joditButtons.push({
        name: 'Email Images',
        text: 'Email Images',
        list: editorImages
    });

    //joditButtons.push({
    //    name: 'Signatures',
    //    list: editorSignatures,
    //    exec: (ed, nodeOrFalse, control, origEvent, btn) => {
    //        let foundTemp = emailSignatures?.find(es => es.repEmailTemplateLibrary_ID === parseInt(control.control.name));
    //        if (foundTemp) {
    //            ed.s.insertHTML("<div id=\"signature\"" + foundTemp.stringContent + "</div>");
    //        }
    //    }
    //});
    

    //joditButtons.push({
    //    name: 'Merge Fields',
    //    list: editorMergeFields,
    //    exec: (ed, nodeOrFalse, control, origEvent, btn) => {
    //        let foundField = editorMergeFields?.find(emf => emf === control.control.name);
    //        if (foundField) {
    //            ed.s.insertHTML(DropInMergeField(control.control.name));
    //        }
    //    }
    //});
    //joditButtons.push({
    //    name: 'Email Images',
    //    list: repEmailImages,
    //    exec: (ed, nodeOrFalse, control, origEvent, btn) => {
    //        let foundImage = repEmailImages?.find(rei => rei === control.control.name);

    //        console.log(foundImage);

    //        if (foundImage) {
    //            ed.s.insertHTML(
    //                `<a href="https://d2p-show-rep-email-images.nyc3.digitaloceanspaces.com/${encodeURIComponent(foundImage)}">
    //                     <img src="https://d2p-show-rep-email-images.nyc3.digitaloceanspaces.com/${encodeURIComponent(foundImage)}" />
    //                   </a>`
    //            );
    //        }
    //    }
    //});

    const fileprops = {
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const isPDF = file.type === 'application/pdf';
            if (!isPDF) {
                toast.error(`${file.name} is not a PDF file. Only PDF files are allowed`);
                return false;
            }
            const newFileList = [...fileList, file];
            setFileList(newFileList);

            return false;
        },
        fileList,
    };

    return (
        <SlidingPane
            className='some-custom-class w-65'
            overlayClassName='showCard'
            isOpen={state.showPane}
            title='D2P Web CM Email Sender'
            onRequestClose={hidePane}
            width={'90%'}
            closeIcon={<i className="fas fa-chevron-right float-left"></i>}
        >
            <div className="slide-pane-body scrollableDiv">
                <div>

                    <Fragment>
                        <div className="row">
                            <div className="form-group col-4">
                                <label>Select Template</label>
                                <select className="ant-input" onChange={selectTemplate} value={selectedTemplate?.repEmailTemplateLibrary_ID}>
                                    <option value={null}>{'<Free Form Text>'}</option>
                                    {templateDropdown.map((t, idx) => <option key={idx} value={t.repEmailTemplateLibrary_ID}>{t.templateName}</option>)}
                                </select>
                            </div>
                            <div className="form-group col-lg-8"></div>

                            <div className="form-group col-6">
                                <label>To:</label>
                                <input className="ant-input" {...register('sendTo')} />
                                <Select
                                    showSearch
                                    allowClear
                                    value={null}
                                    placeholder="+ add contact"
                                    optionFilterProp="label"
                                    style={{ width: '100%', marginTop: 4 }}
                                    options={contacts.map(c => ({
                                        value: c.email,
                                        label: `${c.jsS_name} (${c.contact_type}) — ${c.email}`
                                    }))}
                                    onChange={(email) => addContactToField('sendTo', email)}
                                />
                            </div>

                            <div className="form-group col-6">
                                <label>Cc:</label>
                                <input className="ant-input" {...register('sendCc')} />
                                <Select
                                    showSearch
                                    allowClear
                                    value={null}
                                    placeholder="+ add contact"
                                    optionFilterProp="label"
                                    style={{ width: '100%', marginTop: 4 }}
                                    options={contacts.map(c => ({
                                        value: c.email,
                                        label: `${c.jsS_name} (${c.contact_type}) — ${c.email}`
                                    }))}
                                    onChange={(email) => addContactToField('sendCc', email)}
                                />
                            </div>

                            <div className="form-group col-lg-12">
                                <label>Email Subject</label>
                                <input className="ant-input" {...register('emailSubject')} />
                            </div>

                            <div className="form-group col-lg-6">
                                <label>Document Library Attachments</label>
                                <Select id="ddDocLibraryDocs"
                                    value={getValues().selectedRepDocuments}
                                    className="form-control-custom d-inline-block"
                                    mode="multiple"
                                    placeholder="Select one or more documents from your document library"
                                    onChange={(value) => handleDocLibraryAttachmentsChange(value)}
                                    bordered={false}
                                    style={{ width: '100%', marginTop: 7 }}
                                >
                                    {getValues().repDocuments?.map((doc) => <Option key={doc.repDocumentLibrary_ID} value={doc.repDocumentLibrary_ID}>{doc.documentName} {doc.ownedBy === userInfo.userId ? '' : ' - Shared By ' + doc.ownedBy}</Option>)}
                                </Select>
                            </div>
                            <div className="form-group col-lg-6">
                                <label>Other File Attachments</label>
                                <Upload {...fileprops} className="custom-upload row" accept=".pdf">
                                    <Button icon={<UploadOutlined />}>Click to Attach</Button>
                                </Upload>
                            </div>
                            <div className="col col-lg-12">
                                {/* DnD Overlay (appears above editor when dragging files) */}
                                <div style={{ position: 'relative' }}>
                                    <JoditEditor
                                        ref={editor}
                                        value={content}
                                        tabIndex={1} // tabIndex of textarea
                                        onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                        onChange={(newContent) => { }}
                                        config={{
                                            height: "480",
                                            allowResizeY: true,
                                            spellcheck: true, // enable browser spell check
                                            uploader: {
                                                insertImageAsBase64URI: true
                                            },
                                            buttons: joditButtons,
                                            removeButtons: ['source', 'about', 'video', 'file', 'fullsize', 'preview', 'image'],
                                            readonly: false,
                                            iframe: false,
                                            pasteHTML: true,
                                            askBeforePasteHTML: false,
                                            pasteFromWord: true,
                                            cleanHTML: {
                                                removeEmptyElements: false,
                                                removeEmptyAttributes: false,
                                            }
                                        }}
                                    />
                                    {dndOverlayActive && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                zIndex: 10,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                pointerEvents: 'auto',
                                                background: dndOverlayHighlight ? 'rgba(25, 118, 210, 0.10)' : 'rgba(25, 118, 210, 0.04)',
                                                transition: 'background 0.2s',
                                            }}
                                            onDragOver={e => { e.preventDefault(); setDndOverlayHighlight(true); }}
                                            onDragLeave={e => { e.preventDefault(); setDndOverlayHighlight(false); }}
                                            onDrop={handleOverlayDrop}
                                        >
                                            <div
                                                style={{
                                                    border: dndOverlayHighlight ? '2px solid #1976d2' : '2px dashed #1976d2',
                                                    borderRadius: 8,
                                                    padding: 48,
                                                    background: '#f8faff',
                                                    color: '#1976d2',
                                                    fontWeight: 600,
                                                    fontSize: 22,
                                                    boxShadow: dndOverlayHighlight ? '0 0 16px #1976d2' : 'none',
                                                    transition: 'all 0.2s',
                                                }}
                                            >
                                                Drop HTML file to load content
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row">&nbsp;</div>

                        <div className="position-relative d-flex align-items-center w-100" style={{ minWidth: '600px' }}>
                            {/* LEFT SIDE */}
                            <div className="d-flex align-items-center gap-2">
                                <button className="ant-btn ant-btn-primary" onClick={handleSendEmail}>
                                    Send Email
                                </button>

                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        name="saveToNotes"
                                        {...register("saveToNotes")}
                                        onChange={handleSavetoNotesChange}
                                        id="saveToNotes"
                                    />
                                    <label className="custom-control-label" htmlFor="saveToNotes">
                                        Save To Notes
                                    </label>
                                </div>

                                <div className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        name="saveToImap"
                                        {...register("saveToImap")}
                                        checked={getValues().saveToImap}
                                        onChange={handleSavetoImapChange}
                                        id="saveToImap"
                                    />
                                    <label className="custom-control-label" htmlFor="saveToImap">
                                        Save To Outlook Sent Folder
                                    </label>
                                </div>
                            </div>

                            {/* CENTER BUTTON */}
                            <div className="position-absolute top-50 start-50 translate-middle">
                                <button className="ant-btn ant-btn-danger" onClick={removePersistentEmail}><i className='far fa-trash-alt'></i> &nbsp; Delete this Email</button>
                            </div>

                            {/* RIGHT SIDE */}
                            <div className="ms-auto" style={{ minWidth: '300px' }}>
                                {/* TOP ROW */}
                                <div className="d-flex align-items-center gap-2">
                                    <label className="mb-0 d-flex align-items-center gap-1 flex-grow-1">
                                        Send Test Email To:
                                        <input
                                            className="inline-text-box flex-grow-1"
                                            type="text"
                                            name="testEmailRecipient"
                                            {...register("testEmailRecipient")}
                                            style={{ minWidth: "300px" }}
                                        />
                                    </label>

                                    <button className="ant-btn ant-btn-primary" onClick={handleSendTestEmail}>
                                        Send Test Email
                                    </button>
                                </div>

                                {/* HELPER TEXT (NEW LINE) */}
                                <div className="text-muted small mt-1">
                                    Add more email addresses delimited by a comma
                                </div>
                            </div>
                        </div>

                        {/*</div>*/}
                    </Fragment>

                </div>
            </div>

            <div className="modal-footer">
                <div className="form-group col-12 padding-25-10">
                    <button className="btn ant-btn-primary margin-left-15 float-right" onClick={hidePane}>Close</button>
                </div>
            </div>

        </SlidingPane>
    );
}